var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BrokenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M11.626,13.04l-2.829-2.829c-0.195-0.195-0.195-0.512,0-0.707l0.707-0.707 c0.195-0.195,0.512-0.195,0.707,0l2.829,2.829c0.195,0.195,0.195,0.512,0,0.707l-0.707,0.707 C12.138,13.235,11.821,13.235,11.626,13.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M9.5,19h-3C6.224,19,6,18.776,6,18.5v-1C6,17.224,6.224,17,6.5,17h3c0.276,0,0.5,0.224,0.5,0.5v1 C10,18.776,9.776,19,9.5,19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M18.5,10h-1C17.224,10,17,9.776,17,9.5v-3C17,6.224,17.224,6,17.5,6h1C18.776,6,19,6.224,19,6.5v3 C19,9.776,18.776,10,18.5,10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M39.755,7.348c-3.801-3.339-9.624-2.914-13.202,0.663l-5.564,5.564c-0.391,0.391-0.391,1.024,0,1.414 l2.121,2.121c0.391,0.391,1.024,0.391,1.414,0l5.656-5.656c1.662-1.662,4.361-1.932,6.173-0.436 c2.079,1.716,2.189,4.802,0.328,6.662c-0.775,0.775-3.97,3.97-5.796,5.796c-0.391,0.391-0.387,1.02,0.003,1.411l2.121,2.121 c0.391,0.391,1.024,0.391,1.414,0l5.793-5.793C44.075,17.36,43.921,11.007,39.755,7.348z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M37.789,39.203l-2.829-2.829c-0.195-0.195-0.195-0.512,0-0.707l0.707-0.707 c0.195-0.195,0.512-0.195,0.707,0l2.829,2.829c0.195,0.195,0.195,0.512,0,0.707l-0.707,0.707 C38.3,39.398,37.984,39.398,37.789,39.203z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M30.5,42h-1c-0.276,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.224-0.5,0.5-0.5h1c0.276,0,0.5,0.224,0.5,0.5 v3C31,41.776,30.776,42,30.5,42z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M41.5,31h-3c-0.276,0-0.5-0.224-0.5-0.5v-1c0-0.276,0.224-0.5,0.5-0.5h3c0.276,0,0.5,0.224,0.5,0.5 v1C42,30.776,41.776,31,41.5,31z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M23.475,30.889l-5.656,5.656c-1.662,1.662-4.361,1.932-6.173,0.436 c-2.079-1.716-2.189-4.802-0.328-6.662l5.793-5.793c0.391-0.391,0.391-1.024,0-1.414L14.99,20.99 c-0.391-0.391-1.019-0.395-1.41-0.005c-1.848,1.848-4.401,4.402-5.798,5.798c-3.709,3.709-3.709,9.725,0,13.435 c3.71,3.71,9.725,3.71,13.435,0c1.396-1.396,3.95-3.95,5.798-5.798c0.391-0.391,0.386-1.019-0.005-1.41l-2.121-2.121 C24.499,30.499,23.865,30.499,23.475,30.889z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BrokenLink);
export default __webpack_public_path__ + "static/media/icons8-broken-link.f96337a8d19b99e5d9626bb7ddca615e.svg";
export { ForwardRef as ReactComponent };